import { MutationCache, QueryClient } from '@tanstack/react-query';

import { AuthenticationError } from '#packages/data-collection/types/authentication-error';

export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized';

export class ReactQueryClientService {
  /* private constructor to prevent instantiation */
  private constructor() {}

  static readonly offlineQueryClient = new QueryClient({
    mutationCache: new MutationCache({
      onError: (error) => {
        if (error instanceof AuthenticationError) {
          window.dispatchEvent(new CustomEvent(AUTH_UNAUTHORIZED_EVENT));
        }
      },
    }),
    defaultOptions: {
      queries: {
        networkMode: 'always',
        retry: false,

        staleTime: Infinity,

        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
      },

      mutations: {
        networkMode: 'always',
        retry: false,
      },
    },
  });
}
